import angular from 'angular';

angular.module('cloudX').filter('security', [
  'checkSecurity',
  function(checkSecurity) {
    return function(sec) {
      return checkSecurity(sec);
    };
  },
]);
